import { z } from "zod/v4";

import { castToNumber, castToString } from "../../utils";

import {
  AnalyticsResourceTypeV2List,
  ChannelTypeSchema,
  DatasetIdList,
  DeviceTypeList,
  LandingPagePayloadSchema,
  VisitorTypeSchema,
} from "./base";

export const AnalyzeSitewideRequestBodySchema = z.object({
  datasetId: z.enum(DatasetIdList),
  resourceType: z.enum(AnalyticsResourceTypeV2List),
  startTs: castToString.or(z.number()).nullable(),
  endTs: castToString.or(z.number()).nullable(),
  shopifyDomain: z.string(),
  // latestRunTs: z.string(),
  timezone: z.string(),
  landingPage: LandingPagePayloadSchema.nullish(),
  deviceType: z.enum(DeviceTypeList).nullable(),
  visitorType: z.enum(VisitorTypeSchema).nullable(),
  sourceSitesOrChannels: z.enum(ChannelTypeSchema).array(),
  countryCodes: z.string().array(),
  maxZScore: castToNumber.nullable(),
  interval: z.string().nullish(),
});
export type AnalyzeSitewideRequestBodyType = z.infer<
  typeof AnalyzeSitewideRequestBodySchema
>;

// Frontend to Node Backend Request
export const AnalyzeSitewideFrontendRequestBodySchema =
  AnalyzeSitewideRequestBodySchema.omit({
    shopifyDomain: true,
    // latestRunTs: true,
    timezone: true,
  });

export type AnalyzeSitewideFrontendTinybirdRequestBodyType = z.infer<
  typeof AnalyzeSitewideFrontendRequestBodySchema
>;
